// App chrome only. Navigation identifiers and user-authored content are unchanged.
const es = {
  'Dashboard': 'Panel de control',
  'Overview & analytics': 'Resumen y análisis',
  'API Testing': 'Pruebas de API',
  'Test REST APIs': 'Prueba APIs REST',
  'Flow Testing': 'Pruebas de flujo',
  'E2E test flows': 'Flujos de prueba de extremo a extremo',
  'Test Suites': 'Suites de pruebas',
  'Batch test execution': 'Ejecución de pruebas por lotes',
  'QA lifecycle management': 'Gestión del ciclo de calidad',
  'Projects': 'Proyectos',
  'Manage projects': 'Administra proyectos',
  'Pipeline integration': 'Integración de pipelines',
  'Team': 'Equipo',
  'Manage team members': 'Administra miembros del equipo',
  'Billing': 'Facturación',
  'Payments & invoices': 'Pagos y facturas',
  'Plans': 'Planes',
  'Upgrade your plan': 'Mejora tu plan',
  'User': 'Usuario',
  'Administrator': 'Administrador',
  'Member': 'Miembro',
  'Log out': 'Cerrar sesión',
  'Profile Settings': 'Configuración del perfil',
  'Open menu': 'Abrir menú',
  'Close menu': 'Cerrar menú',
  'Search Sprint QA... (Ctrl+K)': 'Buscar en Sprint QA... (Ctrl+K)',
  'No results for "{query}"': 'No hay resultados para "{query}"',
  'Cannot navigate to {key}: Project information is missing. Please access it through the Sprint QA project view.':
    'No se puede abrir {key}: falta la información del proyecto. Accede desde la vista de proyectos de Sprint QA.',
  'Notifications': 'Notificaciones',
  'Mark all read': 'Marcar todas como leídas',
  'Clear all': 'Borrar todas',
  'No notifications yet': 'Aún no hay notificaciones',
  'Scheduled test results will appear here': 'Los resultados de las pruebas programadas aparecerán aquí',
  'Built:': 'Compilado:',
  'Docs': 'Documentación',
  'Help': 'Ayuda',
  'Support Ticket': 'Ticket de soporte',
  'Free': 'Gratis',
  'Trial': 'Prueba gratuita',
  'Free Trial': 'Prueba gratuita',
  'Business Trial': 'Prueba Business',
};

export const appShellTranslator = (language) => (text, values = {}) => {
  if (typeof text !== 'string') return text;
  const translated = language === 'es' ? (es[text] ?? text) : text;
  return translated.replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match);
};
